import React, { useEffect, useState } from "react"; // useState, useEffect нэмэв
import styled from "styled-components";
import axios from "axios"; // axios нэмэв
import assets from "../../../assets/assets";
import ArtistImage from "./ArtistImage";
import SidebarMenu from "./SidebarMenu";
import { IconController } from "../../Scripts/ImgController";
import ToggleSidebarMenu from "./SidebarMenuSwitch";
import { distributionUrl } from "../../Config/url"; // URL тохиргоог нэмэв
import { useAxiosConfigGlobal } from "../../Config/axios"; // Axios config нэмэв

const Wrapper = styled.div`
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101 !important;
`;

const Sidebar = ({
                   sidebarExpanded,
                   setSidebarExpanded,
                   currentPublisher,
                   setLogoutConfirmation,
                   oneRingRulesAll, // logout хийх функц хэрэгтэй бол
                   drawer = false, // mobile дээр ☰ drawer болж харагдана
                   drawerOpen = false,
                 }) => {
  // drawer үед үргэлж дэлгэрэнгүй харагдана
  const expanded = drawer || sidebarExpanded;
  const accessData = JSON.parse(localStorage.getItem("Current-Access"));
  const axiosConfig = useAxiosConfigGlobal();

  // Цомогтой эсэхийг хадгалах state
  const [hasAlbums, setHasAlbums] = useState(false);

  useEffect(() => {
    // Artist-ийн цомгийн жагсаалтыг шалгах
    axios.get(`${distributionUrl}panel-api/oauth/artist:albums`, axiosConfig)
        .then((res) => {
          // Хэрэв meta.total эсвэл датаны урт нь 0-ээс их байвал харуулна
          const total = res.data.meta?.total || res.data.data?.length || 0;
          if (total > 0) {
            setHasAlbums(true);
          }
        })
        .catch((err) => {
          console.error("Цомог шалгахад алдаа гарлаа", err);
        });
  }, []);

  return (
      <Wrapper
          className={`${
              expanded ? "w-sidebar-expanded" : "w-sidebar-collapsed"
          } duration-300 bg-sidebar ${
              drawer ? (drawerOpen ? "translate-x-0" : "-translate-x-full") : ""
          }`}
      >
        {!drawer && (
          <div
              className="absolute cursor-pointer -right-4 top-7 rounded-full"
              onClick={() => {
                setSidebarExpanded(!sidebarExpanded);
              }}
          >
            <IconController
                src={assets.svg.sidebarArrow}
                alt=""
                className={`bg-white p-1 rounded-full border-4 border-sidebar ${
                    !sidebarExpanded ? "rotate-180" : ""
                }`}
            />
          </div>
        )}

        <div className={`flex flex-col h-full ${drawer ? "overflow-y-auto" : ""}`}>
          <div className={`flex flex-row justify-center items-center px-8 pt-8 ${drawer ? "pb-10" : "pb-20"}`}>
            <a href="/" className="cursor-pointer">
              <div className="flex gap-1">
                <IconController />
                <img src={assets.svg.mmusicLogoWhiteSmall} alt="" />
                <img
                    src={assets.svg.mmusicLogoWhiteText}
                    alt=""
                    className={`duration-300 ${!expanded ? "scale-0" : ""}`}
                />
              </div>
            </a>
          </div>
          <ArtistImage sidebarExpanded={expanded} />
          <div className="flex flex-col flex-1 gap-5">
            <SidebarMenu
                icon={assets.svg.sidebarWallet}
                title="Хэтэвч"
                where=""
                sidebarExpanded={expanded}
                setLogoutConfirmation={setLogoutConfirmation}
            />
            <SidebarMenu
                icon={assets.svg.sidebarStatistic}
                title="Статистик"
                where="statistic"
                sidebarExpanded={expanded}
                setLogoutConfirmation={setLogoutConfirmation}
            />
            <SidebarMenu
                icon={assets.svg.sidebarNote}
                title="Уран бүтээл"
                where="creation"
                sidebarExpanded={expanded}
                setLogoutConfirmation={setLogoutConfirmation}
            />

            {/* Зөвхөн цомогтой үед харагдана */}
            {hasAlbums && (
                <SidebarMenu
                    icon={assets.svg.sidebarNote}
                    title="Цомог"
                    where="album"
                    sidebarExpanded={expanded}
                    setLogoutConfirmation={setLogoutConfirmation}
                />
            )}

            <SidebarMenu
                icon={assets.svg.sidebarProfile}
                title="Профайл"
                where="profile"
                sidebarExpanded={expanded}
                setLogoutConfirmation={setLogoutConfirmation}
            />
          </div>
          <div>
            {accessData?.is_karaoke_active === true ? (
                <div className="pb-6">
                  <ToggleSidebarMenu
                      type="music"
                      icon={assets.svg.shuffle}
                      title="MKaraoke самбар"
                      sidebarExpanded={expanded}
                  />
                </div>
            ) : (
                ""
            )}

            <div className="pb-4">
              <SidebarMenu
                  icon={assets.svg.sidebarLogout}
                  title="Гарах"
                  where="logout"
                  sidebarExpanded={expanded}
                  setLogoutConfirmation={setLogoutConfirmation}
              />
            </div>
          </div>
        </div>
      </Wrapper>
  );
};

export default Sidebar;